// BUG-2634: getFBOrder(tableId, status) returns EVERY order of the table in that status. A session
// the server never closed (KMRES01 T18: an 11-Sep order still IP beside 16-Oct's; HMRES01 G1) can
// come back first, and opening it showed the previous bill's items and closed the live session on
// this device. getTableStatus.orderId names the table's current order (its fbOrderId): open that one.
export const pickTableStatusOrder = (orders = [], statusOrderId, splitTable) => {
  const list = Array.isArray(orders) ? orders.filter(Boolean) : [];
  if (list.length === 0) return null;
  // A split table's orders share the parent's tableId — consider only this split's (or the unsplit) ones.
  const scoped = list.filter((o) => (splitTable ? o.fbSplitTable === splitTable : !o.fbSplitTable));
  const pool = scoped.length > 0 ? scoped : list;
  const byStatus = statusOrderId ? pool.find((o) => o.fbOrderId === statusOrderId) : null;
  if (byStatus) return byStatus;
  // No match: the newest session ("YYYY-MM-DD HH:mm:ss" sorts as text), never just the server's first row.
  return [...pool].sort((a, b) => String(b?.date || "").localeCompare(String(a?.date || "")))[0];
};
